module.exports = __webpack_public_path__ + "static/media/NISM-location-master.e133fcee.xls";